import React, { Component } from 'react';
import { LayoutWithBannerNavbarFooter } from 'layouts';
import ultilitiesService from 'shared/util/ultilitiesService';
// import numeral from 'numeral';
// import moment from 'moment';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons';
import TextTruncate from 'react-text-truncate'; // recommend
import arrowBlack from 'assets/icons/nextBlack.svg';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import baseUrl from 'shared/util/baseUrl';
import {
  COMPONENT_TYPE, PATH, STORAGE_KEY,
} from 'shared/constants';
import { getRTL, getProductDetailsById } from 'shared/redux/selectors';
import { BottomButton } from 'components';
import { connect } from 'react-redux';
import { toggleLanguage } from 'shared/redux/actions';
// import { mapFundDetail } from 'shared/redux/actions/fundFactsheet';
import {
  FundFactsheetHeader,
  FundItemList,
  KeyFacts,
  BarChart,
  Goals,
  LineChart,
  PastPerformanceV2,
  PieChart,
} from './components';
// import productsData from '../ProductRecommendation/data.json';
import './FundFactsheet.scss';

class FundFactsheet extends Component {
  componentDidMount() {
    // const { id } = this.props.match.params;
    const {
      funds,
      history,
      // onMapFundDetail
    } = this.props;

    localStorage.setItem(STORAGE_KEY.CURRENT_PRODUCT_SLIDE, (this.props.location.state ? (this.props.location.state.slide || 0) : 0));

    if (!(funds && funds.length)) {
      history.push(PATH.ASSETS_ALLOCATION);
    }
    // else {
    //   onMapFundDetail(id);
    // }
  }

    goBack = () => {
      this.props.history.goBack();
    };

    render() {
      const {
        currentLocale, history, isRtl, fundDetail, intl,
      } = this.props;

      // console.log(fundDetail);
      return (
        fundDetail ? (
          <LayoutWithBannerNavbarFooter
            // leftButton={<FontAwesomeIcon icon={faLongArrowAltLeft} />}
            leftButton={(<span className="arrow"><img src={arrowBlack} alt="arrow" /></span>)}
            rightButton={ultilitiesService.locale(currentLocale)}
            onLeftClick={this.goBack}
            onRightClick={() => history.push(PATH.LANGUAGE)}
            background={`${baseUrl}/images/compressed/${fundDetail.banner && fundDetail.banner.replace('.png', '.jpg')}`}
            title={fundDetail.title ? (
              <TextTruncate
                line={1}
                element="span"
                truncateText="…"
                text={fundDetail.title}
              />
            ) : ''}
            noTranslate
            className="nw-page-fundfactsheet"
            isRtl={isRtl}
            footerChildren={(
              <BottomButton value={intl.formatMessage({ id: 'products.backToProductOverview' })} onButtonClick={() => this.props.history.push(PATH.PRODUCT_RECOMMENDATION)} isOutlineButton />
            )}
          >
            <FundFactsheetHeader
              // title={intl.formatMessage({ id: data.title })}
              title={fundDetail.title || ''}
              reportingDate={fundDetail.reportingDate || ''}
              logo={fundDetail.logo ? `${baseUrl}/images/${fundDetail.logo}` : undefined}
              description={fundDetail.description ? fundDetail.description : ''}
            />
            { fundDetail.masterData && fundDetail.masterData.map((item, idx) => {
              switch (item.componentType) {
                case COMPONENT_TYPE.KEY_FACTS:
                  return (
                    <KeyFacts
                      key={idx}
                      data={item.data}
                      title={item.title}
                      subTitle={item.subTitle}
                    />
                  );
                case COMPONENT_TYPE.ITEM_LIST:
                  return (
                    item.data && item.data.length !== 0 ? <FundItemList title={item.title} data={item.data} key={idx} /> : null
                  );
                case COMPONENT_TYPE.PIE_CHART:
                  return (
                    item.data && item.data.length !== 0 ? <PieChart title={item.title} data={item.data} key={idx} /> : null
                  );
                case COMPONENT_TYPE.PAST_PERFORMANCE:
                  return (
                    item.data && item.data.length !== 0 ? <PastPerformanceV2 isin={fundDetail.isin} productType={fundDetail.productType} key={idx} data={item.data} /> : null
                  );
                case COMPONENT_TYPE.LINE_CHART:
                  return (
                    <LineChart title={item.title} data={item.data} listKeys={item.listKeys} key={idx} />
                  );
                case COMPONENT_TYPE.GOAL:
                  return <Goals key={idx} />;
                case COMPONENT_TYPE.GOAL_ALT:
                  return <Goals key={idx} altStyle />;
                case COMPONENT_TYPE.PORTFOLIO_STAT:
                  return <KeyFacts key={idx} dateUpdated={item.dateUpdated} data={item.data} title={item.title} subTitle={item.subTitle} altStyle />;
                case COMPONENT_TYPE.HORIZONAL_BAR_CHART:
                  // console.log('geo data', item.data);
                  return item.data.length > 1 ? <BarChart title={item.title} data={item.data} layout="horizontal" key={idx} /> : null;
                case COMPONENT_TYPE.BAR_CHART:
                  return (
                    <BarChart
                      title={item.title}
                      fundDetail={item.data}
                      key={idx}
                    />
                  );
                default:
                  return null;
              }
            })}

          </LayoutWithBannerNavbarFooter>
        ) : <></>
      );
    }
}

const mapStateToProps = (state, props) => {
  const paramID = props.match.params.id;

  return {
    currentLocale: state.rootReducer.language.locale,
    funds: state.fundFactsheetReducer.funds,
    // fundDetail: state.fundFactsheetReducer.fundDetail,
    fundDetail: getProductDetailsById(paramID, state),
    isRtl: getRTL(state.rootReducer),
  };
};

const mapDispatchToProps = ({
  onSwitchLanguage: toggleLanguage,
  // onMapFundDetail: mapFundDetail,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(FundFactsheet)));
